export enum ClaimErrorFieldsEnum {
  id = 'id',
  type = 'type',
  line = 'line',
  instance = 'instance',
  detail = 'detail',
}

export enum ClaimsTypeEnum {
  pendingDisposition = 'pendingDisposition',
  dispositioned = 'dispositioned',
}

export enum ClaimsEOBStatusEnum {
  notRequested = 0,
  requested = 1,
  requestedNotReceivedOnTime = 2,
  received = 3,
  RequestedButBatchNotComplete = 4,
}

export enum CoverageStatusEnum {
  active = 'active',
  inactive = 'inactive',
  unknown = 'unknown',
}

export enum EBVTypeEnum {
  inNetwork = '1',
  outNetwork = '2',
}

export enum ClaimStatusTypeEnum {
  unknown = 'unknown',
  inProgress = 'inProgress',
  statusUpdateNeeded = 'statusUpdateNeeded',
  workCompleted = 'workCompleted',
  diagnosticClaim = 'diagnosticClaim',
}

export enum ClaimDetailsGroupsEnum {
  provider = 'provider',
  patient = 'patient',
  insurer = 'insurer',
  claim = 'claim',
  // subscriber = 'subscriber',
  // callInformation = 'call information',
  // followUp = 'follow up',
}

export enum ClaimErrorTableHeaderEnum {
  line = 'line',
  column = 'column',
  problem = 'problem',
}

export enum ClaimErrorProblemTypeEnum {
  line = 'line',
  column = 'column',
}

export enum ClaimEnum {
  oaiClaimId = 'oaiClaimId',
  entityBagId = 'entityBagId',
  oaiStatus = 'oaiStatus',
  owner = 'owner',
  location = 'location',
  ownerId = 'ownerId',
  insurerName = 'insurerName',
  insurerPlanName = 'insurerPlanName',
  insurerClaimId = 'insurerClaimId',
  patientId = 'patientId',
  visitId = 'visitId',
  billerNpi = 'billerNpi',
  billerTaxId = 'billerTaxId',
  billerName = 'billerName',
  levelOfSupport = 'levelOfSupport',
  patientFirstName = 'patientFirstName',
  patientLastName = 'patientLastName',
  patientDob = 'patientDob',
  admitDate = 'admitDate',
  patientState = 'patientState',
  insurerId = 'insurerId',
  subscriberFirstName = 'subscriberFirstName',
  subscriberLastName = 'subscriberLastName',
  subscriberId = 'subscriberId',
  claimSubmissionDate = 'claimSubmissionDate',
  claimAmount = 'claimAmount',
  outstandingBalance = 'outstandingBalance',
  claimDisposition = 'claimDisposition',
  oaiWorked = 'oaiWorked',
  created = 'created',
  updated = 'updated',
  claimId = 'claimId',
}

export interface IsActivePhoneNumber {
  phoneNumber: string
  isActive: boolean
}

export interface MaintenanceNotification {
  notificationId: number
  startOn: string
  endOn: string
  title: string
  message: string
  isPreLogin: boolean
  created: string
  updated: string
}
